import React, { Component, Fragment } from 'react';
import { View, Button, Modal, Spinner, Card, PhoneNumberInput, Loc } from '../UIElements/All.js';
import { Colors, ButtonColors, ModalColors } from '../Managers/ThemeManager';
import {AlertCard} from "../UIElements/AlertCard";

import { lookUpUserByPhone, createUserByPhone, setSaleUser, checkPhoneNumberValidity, isFeatureFlagEnabled, isDuplicateEmailExists } from '../Managers/NetworkManager';
import { stringPhoneValue, isRetail } from '../Managers/Utils';
import { pop, push, replace } from '../Managers/AppActions';
import { close, backToScan, setPageTitles } from '../Managers/LSLoyaltyAPI';

import PageContainer from '../UIElements/PageContainer';

var LocalizationManager = require('../Managers/LocalizationManager.js');

const PREDICTION_DELAY = 300;
const FEATURE_FLAG_NAME = 'LSR-16641_RELEASE_ENABLE_EMAIL_SYNC';

var _predictionTimeout = null;

export default class CustomerPhoneNumber extends Component
{
  constructor(props)
  {
    super(props);
    var state = this.props.location.state;
    state.isInError = false;
    state.continueButtonEnabled = false;
    state.hasMatchedUser = false;
    state.predictedPhone = "";
    state.predictions = [];
    state.lsPhoneDescriptor = null;
    state.lsPhoneNumber = null;
    state.providedPhoneNumbers = [];
    state.showEmailFeature = {isFeatureFlagEnabled: false};
    state.isDuplicateEmail = false;
    this.state = state;
  }

  componentDidMount()
  {
    LocalizationManager.localizedStringForKey("INPUT_PHONE_NUMBER_PAGE_TITLE", [], (retrievedString)=>
    {
      setPageTitles("asf",retrievedString, "asdf");
    });

    var checkEmailAddress = this.getEmailAddress()
    if(checkEmailAddress.length > 0) {
      isDuplicateEmailExists(this.state.urlInputs, checkEmailAddress).then((result) => {
        this.setState({isDuplicateEmail: result})
      })
    }
    isFeatureFlagEnabled(this.state.urlInputs, FEATURE_FLAG_NAME).then((result) => {
      this.setState({showEmailFeature: result})
    })

    var contactsToCheck = this.updateLSPhoneNumber() ? this.updateLSPhoneNumber() : [];
    if (contactsToCheck.length > 0) {
      this._phoneNumberInput.setFullPhoneNumber(contactsToCheck[0].number);
    }
  }

  getEmailAddress() {
    const emailAddress = this.state.lsUser && this.state.lsUser.Contact && this.state.lsUser.Contact.Emails ? this.state.lsUser.Contact.Emails.ContactEmail : "";
    const customerEmailAddress = Array.isArray(emailAddress) ? emailAddress[0].address : (emailAddress ? emailAddress.address : "")
    return customerEmailAddress
  }

  clearSelected()
  {
  	this._phoneNumberInput.clearSelected();
  }

  phoneNumberChanged(newPhoneNumber)
  {
    var UPDATE_PREDICTIONS_LENGTH = 7;

    newPhoneNumber = this.getUnformattedPhoneNumber(newPhoneNumber);
    if( newPhoneNumber.length >= UPDATE_PREDICTIONS_LENGTH ) this.updatePredictions(newPhoneNumber);
  }

  okSelected()
  {
    if( !this.state.continueButtonEnabled ) return;

    var urlInputs = this.state.urlInputs;
  	if( this.state.hasMatchedUser )
  	{
  		var qrCode = {userID:this.state.predictedUser.UserID, hash:this.state.predictedUser.Hash, type:"phone", appID:this.state.appID};
  		replace(this, 'customerOptions', {qrCode, hidePay:true, urlInputs})
  	}
  	else
  	{
  		var self = this;
  		this._pageContainer.getModal().showSpinner("CREATING_USER_SPINNER");
  		createUserByPhone(this._phoneNumberInput.getCountryCode(), this.getUnformattedPhoneNumber(this._phoneNumberInput.getPhoneNumber()), urlInputs).then((result, error)=>
  		{
  			self._pageContainer.getModal().hide();
        if( error != null )
        {
          if (error.code === -69) {
            self._pageContainer.getModal().showAlert("PHONE_NUMBER_IN_USE_ALERT_TITLE", "PHONE_NUMBER_IN_USE_ALERT_BODY", ["NO_BUTTON", "CHANGE_CUSTOMER_BUTTON"], [() => {
              self._pageContainer.getModal().hide();
            }, () => {
              self._pageContainer.getModal().showSpinner("ATTACHING_CUSTOMER_SPINNER");
              setSaleUser(result.UserID, urlInputs.saleID, urlInputs).then((newUser, error) => {
                self._pageContainer.getModal().hide();
                console.log(newUser);
                if (error == null) {
                  var qrCode = {userID: newUser.UserID, hash: newUser.Hash, type: "phone", appID: self.state.appID};
                  replace(self, 'customerOptions', {qrCode, hidePay: true, urlInputs})
                }
              })
            }]);
          }
          else{
            self._pageContainer.getModal().showAlert("SOMETHING_WENT_WRONG_ERROR_TITLE", "CREATE_ACCOUNT_ERROR_BODY", ["BACK_TO_SALE_BUTTON"], [()=>{close(urlInputs)}]);
          }
        }
        else
        {
            var qrCode = {userID:result.UserID, hash:result.Hash, type:"phone", appID:self.state.appID};
            replace(self, 'customerOptions', {qrCode, hidePay:true, urlInputs})
        }
  		})
  	}
  }

  resetPredictions()
  {
    this.setPredictions([]);
  }

  updatePredictions(phoneNumber)
  {
    var self = this;

    if( this._phoneNumberInput.getPredictedPhoneNumber().indexOf(phoneNumber) === 0 ) return; // early return if the prediction is still valid

    // empty the prediction since it is not valid
    self._phoneNumberInput.setPredictedPhoneNumber("");

    if( _predictionTimeout != null ) clearTimeout(_predictionTimeout);

    const phoneNumberInput = phoneNumber;
    _predictionTimeout = setTimeout(()=>
    {
      var phoneNumber = this.getUnformattedPhoneNumber(self._phoneNumberInput.getPhoneNumber());
      if( phoneNumber != phoneNumberInput ) return; // early return because its changed

      self.setState({isShowingSpinner:true});
      lookUpUserByPhone(phoneNumberInput, self.state.urlInputs).then((result)=>
      {
        self.setState({isShowingSpinner:false});
      	if( phoneNumber != phoneNumberInput ) return; // early return because its changed

        self.setPredictions(result);

        if( self._okSelectedOnUpdate ) self.okSelected();
        self._okSelectedOnUpdate = false;
      })
    }, PREDICTION_DELAY)
  }

  setPredictions(predictions)
  {
    var self  = this;
    if( typeof predictions === 'undefined' ) predictions = [];

    if( _predictionTimeout != null ) clearTimeout(_predictionTimeout);

    _predictionTimeout = setTimeout(()=>
    {
      var phoneNumber = this.getUnformattedPhoneNumber(this._phoneNumberInput.getPhoneNumber());
      var newPredictions = [];
      var foundMatch = false;
      for( var i = 0; i < predictions.length; i++ )
      {
        var user = predictions[i];
        if( user.PhoneNumber.indexOf(phoneNumber) === 0 )
        {
          foundMatch = true;
          newPredictions.push(user);
        }
      }

      if( foundMatch )
      {
        this.setPredictedUser(newPredictions[0]);
        LocalizationManager.localizedStringForKey("CONTINUE_BUTTON", [], (retrievedString)=>
        {
          self.setState({buttonTitle:retrievedString, buttonIsEnabled:true, hasMatchedUser:true, continueButtonEnabled:true});
        });
      }
      else
      {
        this.setPredictedUser(null);

        var self = this;
        var countryCode = this._phoneNumberInput.getCountryCode();
        checkPhoneNumberValidity(countryCode, phoneNumber, self.state.urlInputs).then((result, error)=>
        {
          if( phoneNumber != this.getUnformattedPhoneNumber(self._phoneNumberInput.getPhoneNumber())) return; // early return because its changed

          var phoneNumberValid = error === null;
          self.setState({isInError: !phoneNumberValid});
          if( phoneNumberValid )
          {
            LocalizationManager.localizedStringForKey("CREATE_ACCOUNT_BUTTON", [], (retrievedString)=>
            {
              self.setState({buttonTitle:retrievedString, buttonIsEnabled:true, hasMatchedUser:false, continueButtonEnabled:true, isShowingSpinner:false});
            });
          }
          else
          {
            LocalizationManager.localizedStringForKey("TYPE_PHONE_NUMBER_BUTTON", [], (retrievedString)=>
            {
              self.setState({buttonTitle:retrievedString, buttonIsEnabled:false, hasMatchedUser:false, continueButtonEnabled:false, isShowingSpinner:false});
            });
          }
        })
      }
    }, PREDICTION_DELAY)
  }

  setPredictedUser(predictedUser)
  {
  	this.setState({predictedUser});
    this._phoneNumberInput.setPredictedPhoneNumber(predictedUser == null ? "" : predictedUser.PhoneNumber);
  }

  propsHasEmptyPhoneNumber()
  {
    var self = this;
    LocalizationManager.localizedStringForKey("TYPE_PHONE_NUMBER_BUTTON", [], (retrievedString)=>
    {
      self.setState({buttonTitle:retrievedString, buttonIsEnabled:false, hasMatchedUser:false, continueButtonEnabled:false});
    });

  }

  updateLSPhoneNumber()
  {
    if( typeof this.state.lsUser !== 'undefined' )
    {
      var lsUser = this.state.lsUser;

      if( typeof lsUser.Contact.Phones.ContactPhone !== 'undefined' ) // only 1
      {
        var contactsToCheck = [];
        var contactPhone = lsUser.Contact.Phones.ContactPhone;
        if(contactPhone) {
          if (!Array.isArray(contactPhone)){
            contactPhone = [contactPhone];
          }

          contactPhone.forEach((number, index) => {
            return contactPhone[index].number = this.getUnformattedPhoneNumber(contactPhone[index].number);
          });

          var prioritizedUseType = ["Mobile", "Home", "Work", "Pager", "Fax"]; // first one is highest priority
          prioritizedUseType.forEach(phoneType =>
              contactsToCheck.push(contactPhone.find(function (_ref){
                var useType = _ref.useType;
                return useType === phoneType;
              })));

          contactsToCheck = contactsToCheck.filter(function(e){return e !== undefined});
          this.setState({providedPhoneNumbers: contactsToCheck});
          return contactsToCheck;
        }
      }
    }
  }

  checkLSContacts(lsContactsToCheck, index = 0) // recursive function, do not set index on first call
  {
    if( index >= lsContactsToCheck.length ) return; // completed

    var contact = lsContactsToCheck[index];
    var lsPhoneNumber = contact.number;
    var lsPhoneDescriptor = contact.useType;
    var countryCode = this._phoneNumberInput.getCountryCodeFromFullPhoneNumber(lsPhoneNumber);
    if( countryCode == null ) // there is no country code valid for this phone number
    {
        this.checkLSContacts(lsContactsToCheck, index+1);
    }
    else // check if the format is right
    {
      var self = this;
      checkPhoneNumberValidity(countryCode, lsPhoneNumber, this.state.urlInputs, (result, error)=>
      {
        var phoneNumberValid = error == null;
        if( phoneNumberValid )
        {
          self.setState({lsPhoneNumber, lsPhoneDescriptor});
        }
        else
        {
          self.checkLSContacts(lsContactsToCheck, index+1);
        }
      })
    }
  }

  getUnformattedPhoneNumber(phoneNumber){
    return phoneNumber.replace(/\D/g,'');
  }

  getSectionCard(title, description) {
    return (
      <Fragment>
        {
          typeof this.state.urlInputs !== 'undefined' && typeof title !== 'undefined' && isRetail() && !this.state.urlInputs.mobile ?
            <View style={{ width: 700, alignSelf: 'center', marginTop: 20, marginBottom: 25, flexDirection: 'column', flex: -1 }}>
              <View style={{fontSize: 18, marginBottom: 8}}>
                <View>
                  <Loc locKey={title}></Loc>
                </View>
              </View>
              <View style={{
                backgroundColor: Colors.text1,
                height: 1,
                marginTop: 1,
                flex: -1,
                alignSelf: 'stretch'
              }}/>
              <View style={{fontSize: 16, marginTop: 10}}>
                <Loc locKey={description}></Loc>
              </View>
            </View>
            : null
        }
      </Fragment>
    )
  }

  getEmailInputCard(emailAddress) {
    return (
      emailAddress && emailAddress.length > 0 && (
        <Fragment>
          <View style={{
            flex: -1,
            height: 60,
            margin: 10,
            flexDirection: 'row',
            opacity: 1
          }}>
            <View style={{ flex: 1, alignSelf: 'stretch', flexDirection: 'row', borderRadius: 4, background: '#F5F7FF', fontSize: 32, borderWidth: 1, borderStyle: 'solid', borderColor: Colors.input1Border}}>
              <View style={{ flex: 1, alignSelf: 'stretch', position: 'relative', flexDirection: 'row', alignItems: 'center', textAlign: 'right', justifyContent: 'center', padding: 4, opacity: 1}}>
                <input value={emailAddress} readOnly maxLength="16" onChange={this.handleChange} style={{ flex: -1, position: 'relative', left: 0, right: 0, bottom: 2, top: 2, border: 0, width: '100%', opacity: 1, flexDirection: 'row', alignItems: 'Center', textAlign: 'left', justifyContent: isRetail() ? 'flex-start' : 'center', color: Colors.input1Text, fontSize: 32, paddingLeft: 12, background: '#F5F7FF'}}></input>
              </View>
            </View>
          </View>
        </Fragment>
      )
    )
  }

  getAlertCard(title, description) {
    return (
      <View style={{margin: 10, textAlign: 'left'}}>
        <AlertCard
          title={title}
          description={description}/>
      </View>
    )
  }

  render() {
    const showEmailFeatureEnabled = this.state.showEmailFeature.isFeatureFlagEnabled
    const isConsentRequired = (this.state.lsUser && this.state.lsUser.Contact && this.state.lsUser.Contact.noEmail === "true")
    const customerEmailAddress = this.getEmailAddress()
    const isEmailProvided = (customerEmailAddress.length > 0)
    const isDuplicateEmail = (this.state.isDuplicateEmail === true)
    var self = this;
    var phoneInputHeight = 60;
    var providedPhoneNumber = this.state.providedPhoneNumbers ? this.state.providedPhoneNumbers : [];
    var mobileNumber = providedPhoneNumber.findIndex(x => x.useType == "Mobile") == -1 ? null : providedPhoneNumber[providedPhoneNumber.findIndex(x => x.useType == "Mobile")].number;
    var homeNumber = providedPhoneNumber.findIndex(x => x.useType == "Home") == -1 ? null : providedPhoneNumber[providedPhoneNumber.findIndex(x => x.useType == "Home")].number;
    var workNumber = providedPhoneNumber.findIndex(x => x.useType == "Work") == -1 ? null : providedPhoneNumber[providedPhoneNumber.findIndex(x => x.useType == "Work")].number;

    return (
      !showEmailFeatureEnabled ?
        <PageContainer
          ref={(a) => { this._pageContainer = a; }}
          urlInputs={this.state.urlInputs}
          tipTitle={"ENTER_PHONE_NUMBER_TIP_TITLE"}
          tipBody={"ENTER_PHONE_NUMBER_TIP_BODY"}
          title={"PHONE_NUMBER_TITLE"}>
          <Card style={{flex: isRetail() ? -1 : 1, alignSelf: 'stretch', flexDirection: 'column'}}>
            <PhoneNumberInput
              ref={(a) => { this._phoneNumberInput = a; }}
              style={{flex: -1, height: phoneInputHeight, margin: 12, flexDirection: 'row', opacity: 1}}
              colors={Colors}
              phoneNumberChanged={(newNumber) => {
                self.phoneNumberChanged(newNumber)
              }}
              okSelected={() => {
                self.okSelected()
              }}
              needsNewPredictedPhoneNumber={(phoneNumber) => {
                self.updatePredictions(phoneNumber)
              }}
              phoneLocales={this.state.phoneLocales}
              isInError={this.state.isInError}/>
            {
              isRetail() && self.state.isInError ?
                <p style={{marginLeft: 12, textAlign: "left", color: "red", fontSize: 14, border: 0}}>
                  <Loc locKey={"INCORRECT_PHONE_NUMBER_ALERT"}></Loc>
                </p>
                :
                null
            }
            {
              isRetail() && self.state.lsPhoneNumber != null ?
                <View style={{
                  flex: 1,
                  margin: 12,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'stretch',
                  fontSize: 22
                }}>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => {
                      self._phoneNumberInput.setFullPhoneNumber(self.state.lsPhoneNumber);
                      // self._okSelectedOnUpdate = true;
                    }} type={5} colors={ButtonColors} style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {self.state.lsPhoneDescriptor + ": " + stringPhoneValue(self.state.lsPhoneNumber)}
                    </Button>
                  </View>
                </View>
                : null
            }
            {
              isRetail() && (Array.isArray(providedPhoneNumber)) ?
                <View style={{
                  flex: 1,
                  margin: 12,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'stretch'
                }}>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button
                      enabled={mobileNumber}
                      onPress={() => {
                        this.setState({currentCountryIndex: 0});
                        self._phoneNumberInput.setFullPhoneNumber(mobileNumber ? mobileNumber : "");
                        self.resetPredictions();
                      }} type={mobileNumber ? 5 : 6} colors={ButtonColors}
                      style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <View style={{
                        alignSelf: 'center',
                        textAlign: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        fontSize: '90%'
                      }}>
                        <Loc locKey="MOBILE_NUMBER_BUTTON"></Loc>: {mobileNumber ? mobileNumber :
                        <Loc locKey="NOT_APPLICABLE_LABEL"></Loc>}
                      </View>
                    </Button>
                    <Button
                      enabled={homeNumber}
                      onPress={() => {
                        this.setState({currentCountryIndex: 0});
                        self._phoneNumberInput.setFullPhoneNumber(homeNumber ? homeNumber : "");
                        self.resetPredictions();
                      }} type={homeNumber ? 5 : 6} colors={ButtonColors}
                      style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <View style={{
                        alignSelf: 'center',
                        textAlign: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        fontSize: '90%'
                      }}>
                        <Loc locKey="HOME_NUMBER_BUTTON"></Loc>: {homeNumber ? homeNumber :
                        <Loc locKey="NOT_APPLICABLE_LABEL"></Loc>}
                      </View>
                    </Button>
                    <Button
                      enabled={workNumber}
                      onPress={() => {
                        this.setState({currentCountryIndex: 0});
                        self._phoneNumberInput.setFullPhoneNumber(workNumber ? workNumber : "");
                        self.resetPredictions();
                      }} type={workNumber ? 5 : 6} colors={ButtonColors}
                      style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <View style={{
                        alignSelf: 'center',
                        textAlign: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        fontSize: '90%'
                      }}>
                        <Loc locKey="WORK_NUMBER_BUTTON"></Loc>: {workNumber ? workNumber :
                        <Loc locKey="NOT_APPLICABLE_LABEL"></Loc>}
                      </View>
                    </Button>
                  </View>
                </View>
                : null
            }
            {
              !isRetail() || this.state.urlInputs.mobile ?
                <View style={{
                  flex: 1,
                  margin: 12,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'stretch',
                  fontSize: 22
                }}>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this._phoneNumberInput.numSelected(1)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"1"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(2)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"2"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(3)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"3"}
                    </Button>
                  </View>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this._phoneNumberInput.numSelected(4)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"4"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(5)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"5"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(6)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"6"}
                    </Button>
                  </View>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this._phoneNumberInput.numSelected(7)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"7"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(8)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"8"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(9)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"9"}
                    </Button>
                  </View>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this.deleteSelected()} type={4} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <Loc locKey="DELETE_BUTTON"></Loc>
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(0)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"0"}
                    </Button>
                    <Button onPress={() => this.clearSelected()} type={4} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <Loc locKey="CLEAR_BUTTON"></Loc>
                    </Button>
                  </View>
                </View>
                : null
            }
            <View style={{alignSelf: 'stretch', flex: -1, flexDirection: isRetail() ? 'row' : 'column'}}>
              <Button
                onPress={() => this.okSelected()}
                type={2}
                enabled={this.state.continueButtonEnabled}
                colors={ButtonColors}
                style={{
                  alignSelf: 'stretch',
                  margin: 12,
                  width: -1,
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                {
                  this.state.isShowingSpinner ?
                    <Spinner color={ModalColors.border}/>
                    :
                    (this.state.hasMatchedUser ?
                        <Loc locKey="CLEAR_BUTTON"></Loc>
                        : <Loc locKey="CREATE_BUTTON"></Loc>
                    )
                }
              </Button>
            </View>
          </Card>
        </PageContainer>
        :
        <PageContainer
          ref={(a) => { this._pageContainer = a; }}
          urlInputs={this.state.urlInputs}
          description={"ENTER_PHONE_NUMBER_TIP_BODY_NEW"}
          isRequired={true}
          title={"PHONE_NUMBER_TITLE"}>

          <Card style={{flex: isRetail() ? -1 : 1, alignSelf: 'stretch', flexDirection: 'column'}}>
            <PhoneNumberInput
              ref={(a) => { this._phoneNumberInput = a; }}
              style={{flex: -1, height: phoneInputHeight, margin: 12, flexDirection: 'row', opacity: 1}}
              colors={Colors}
              phoneNumberChanged={(newNumber) => {
                self.phoneNumberChanged(newNumber)
              }}
              okSelected={() => {
                self.okSelected()
              }}
              needsNewPredictedPhoneNumber={(phoneNumber) => {
                self.updatePredictions(phoneNumber)
              }}
              phoneLocales={this.state.phoneLocales}
              isInError={this.state.isInError}/>
            {
              isRetail() && self.state.isInError ?
                <p style={{marginLeft: 12, textAlign: "left", color: "red", fontSize: 14, border: 0}}>
                  <Loc locKey={"INCORRECT_PHONE_NUMBER_ALERT"}></Loc>
                </p>
                :
                null
            }
            {
              isRetail() && self.state.lsPhoneNumber != null ?
                <View style={{
                  flex: 1,
                  margin: 12,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'stretch',
                  fontSize: 22
                }}>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => {
                      self._phoneNumberInput.setFullPhoneNumber(self.state.lsPhoneNumber);
                      // self._okSelectedOnUpdate = true;
                    }} type={5} colors={ButtonColors} style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {self.state.lsPhoneDescriptor + ": " + stringPhoneValue(self.state.lsPhoneNumber)}
                    </Button>
                  </View>
                </View>
                : null
            }
            {
              isRetail() && (Array.isArray(providedPhoneNumber)) ?
                <View style={{
                  flex: 1,
                  margin: 12,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'stretch'
                }}>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button
                      enabled={mobileNumber}
                      onPress={() => {
                        this.setState({currentCountryIndex: 0});
                        self._phoneNumberInput.setFullPhoneNumber(mobileNumber ? mobileNumber : "");
                        self.resetPredictions();
                      }} type={mobileNumber ? 5 : 6} colors={ButtonColors}
                      style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <View style={{
                        alignSelf: 'center',
                        textAlign: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        fontSize: '90%'
                      }}>
                        <Loc locKey="MOBILE_NUMBER_BUTTON"></Loc>: {mobileNumber ? mobileNumber :
                        <Loc locKey="NOT_APPLICABLE_LABEL"></Loc>}
                      </View>
                    </Button>
                    <Button
                      enabled={homeNumber}
                      onPress={() => {
                        this.setState({currentCountryIndex: 0});
                        self._phoneNumberInput.setFullPhoneNumber(homeNumber ? homeNumber : "");
                        self.resetPredictions();
                      }} type={homeNumber ? 5 : 6} colors={ButtonColors}
                      style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <View style={{
                        alignSelf: 'center',
                        textAlign: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        fontSize: '90%'
                      }}>
                        <Loc locKey="HOME_NUMBER_BUTTON"></Loc>: {homeNumber ? homeNumber :
                        <Loc locKey="NOT_APPLICABLE_LABEL"></Loc>}
                      </View>
                    </Button>
                    <Button
                      enabled={workNumber}
                      onPress={() => {
                        this.setState({currentCountryIndex: 0});
                        self._phoneNumberInput.setFullPhoneNumber(workNumber ? workNumber : "");
                        self.resetPredictions();
                      }} type={workNumber ? 5 : 6} colors={ButtonColors}
                      style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <View style={{
                        alignSelf: 'center',
                        textAlign: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        fontSize: '90%'
                      }}>
                        <Loc locKey="WORK_NUMBER_BUTTON"></Loc>: {workNumber ? workNumber :
                        <Loc locKey="NOT_APPLICABLE_LABEL"></Loc>}
                      </View>
                    </Button>
                  </View>
                </View>
                : null
            }
            {
              !isRetail() || this.state.urlInputs.mobile ?
                <View style={{
                  flex: 1,
                  margin: 12,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'stretch',
                  fontSize: 22
                }}>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this._phoneNumberInput.numSelected(1)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"1"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(2)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"2"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(3)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"3"}
                    </Button>
                  </View>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this._phoneNumberInput.numSelected(4)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"4"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(5)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"5"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(6)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"6"}
                    </Button>
                  </View>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this._phoneNumberInput.numSelected(7)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"7"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(8)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"8"}
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(9)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"9"}
                    </Button>
                  </View>
                  <View style={{flex: -1, height: 60, flexDirection: 'row', alignItems: 'stretch'}}>
                    <Button onPress={() => this.deleteSelected()} type={4} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <Loc locKey="DELETE_BUTTON"></Loc>
                    </Button>
                    <Button onPress={() => this._phoneNumberInput.numSelected(0)} type={1} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      {"0"}
                    </Button>
                    <Button onPress={() => this.clearSelected()} type={4} colors={ButtonColors}
                            style={{flex: 1, height: -1, alignSelf: 'stretch', margin: 2}}>
                      <Loc locKey="CLEAR_BUTTON"></Loc>
                    </Button>
                  </View>
                </View>
                : null
            }
          </Card>
          <View style={{marginTop: 30}}/>
          {this.getSectionCard("EMAIL_TITLE", "ENTER_EMAIL_TIP_BODY")}
          <Card style={{alignSelf: 'stretch', flexDirection: 'column', padding: 5}}>
            {isEmailProvided ?
              this.getEmailInputCard(customerEmailAddress)
              :
              this.getAlertCard("NO_EMAIL_TITLE", "NO_EMAIL_TEXT")
            }
            {!isDuplicateEmail && isEmailProvided && isConsentRequired &&
            this.getAlertCard("CUSTOMER_CONSENT_TITLE", "CUSTOMER_CONSENT_TEXT")
            }
            {isDuplicateEmail &&
            this.getAlertCard("EMAIL_IN_USE_TITLE", "EMAIL_IN_USE_TEXT")
            }
          </Card>
          <View style={{
            width: 700,
            alignSelf: 'center',
            marginTop: 40,
            marginBottom: 20,
            flexDirection: 'column',
            flex: -1
          }}>
            <View style={{alignSelf: 'stretch', flex: -1, flexDirection: isRetail() ? 'row' : 'column'}}>
              <Button
                onPress={() => this.okSelected()}
                type={2}
                enabled={this.state.continueButtonEnabled}
                colors={ButtonColors} style={{
                alignSelf: 'stretch',
                width: -1,
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {
                  this.state.isShowingSpinner ?
                    <Spinner color={ModalColors.border}/>
                    :
                    (this.state.hasMatchedUser ?
                        <Loc locKey="CLEAR_BUTTON"></Loc>
                        : <Loc locKey="CREATE_BUTTON"></Loc>
                    )
                }
              </Button>
            </View>
          </View>
        </PageContainer>
    );
  }
}

